import React from 'react'
import DownloadIcon from '@src/icons/DownloadIcon'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { FormattedMessage } from 'react-intl'
import messages from '../../../../messages'
import { Grid } from '@material-ui/core'
import { EventActions } from '@utils/analytics/types'
import { sendConfiguratorGADownloadEvent } from '@utils/analytics/configuratorAnalytics'
import { ConfiguratorProductInput } from '@src/types/graphql-types'

const useStyles = makeStyles((theme: Theme) => ({
  print: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 900,
    color: theme.palette.primary.main,
    paddingLeft: theme.spacing(0.5),
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(16),
    alignSelf: 'center',
    marginRight: theme.spacing(2),
  },
}))
interface DownloadSummaryProps {
  productDetails: ConfiguratorProductInput
}
const DownloadSummary: React.FC<DownloadSummaryProps> = (props) => {
  const classes = useStyles()
  const { productDetails } = props

  const url = `/configurator-order/summary/genomics?product=${productDetails.productType}&participantId=${productDetails.participantId}&locale=${productDetails.locale}&country=${productDetails.countryCode}`

  return (
    <Grid container>
      <DownloadIcon fontSize="small" className={classes.icon} />
      <Typography className={classes.print}>
        <Link
          id="customCrispr-download-summary-link"
          href={url}
          className={classes.print}
          onClick={() =>
            sendConfiguratorGADownloadEvent(
              EventActions.Summary,
              `${productDetails.productType}`
            )
          }
          download
        >
          <FormattedMessage {...messages.CONF_DOWNLOAD_PRINT_SUMMARY} />
        </Link>
      </Typography>
    </Grid>
  )
}
export default DownloadSummary
